/**
 * dataCy.ts
 *
 * Constants related to cypress, this includes ids and data-cys
 */
// data-cy constants
// note: we should move towards using data-cy instead of id

export const DATA_CY_DOCKVIEW_TAB = "dockview-tab";

export const DATA_CY_TABLE_SEARCH_INPUT = "table-search-input";
export const DATA_CY_PERSPECTIVE_CAMERA_POSITION = "perspective-camera-position";
export const DATA_CY_ORBIT_TARGET = "orbit-target-coordinates";

export const DATA_CY_ORBIT_TARGET_LLE = "orbit-target-lle";
export const DATA_CY_CAMERA_POSITION_LLE = "camera-position-lle";

export const DATA_CY_ORBIT_TARGET_LLE_FIELD = "orbit-target-lle-field";
export const DATA_CY_CAMERA_POSITION_LLE_FIELD = "camera-position-lle-field";
export const DATA_CY_CAMERA_LLE_SUBMIT_BUTTON = "camera-lle-submit-button";

export const DATA_CY_FILTER_POPOVER = "filter-popover";
export const DATA_CY_FILTER_TOOLBAR = "filter-toolbar";
export const DATA_CY_FILTER_TOOLBAR_TRIGGER = "filter-toolbar-trigger";
export const DATA_CY_BASIC_FILTERS = "basic-filters";
export const DATA_CY_FILTER_INPUT = "filter-input";
export const DATA_CY_NO_DATA_CALLOUT = "filter-no-data-callout";
export const DATA_CY_FILTERED_PKS = "filtered-pks";

export const DATA_CY_SUBSURFACE_CANVAS = "subsurface-canvas";
export const DATA_CY_SUBSURFACE_VIEW = "subsurface-view";
export const DATA_CY_WELL_CAMERA_LOCK_OVERLAY = "well-camera-lock-overlay";
export const DATA_CY_WELL_CAMERA_LOCK_CLOSE = "well-camera-lock-close";
export const DATA_CY_TABLE = "table-body";
export const DATA_CY_TABLE_HEAD = "table-head";
export const DATA_CY_TABLE_BODY = "data-table-body";
export const DATA_CY_TABLE_SCROLL_CONTAINER = "data-table-scroll-container";
export const DATA_CY_EXPAND_TABLE = "data-table-expand";
export const DATA_CY_COLLAPSE_TABLE = "data-table-collapse";
export const DATA_CY_TABLE_FOOTER = "table-footer";
export const DATA_CY_TABLE_ROW = "table-row";
export const DATA_CY_TABLE_EXPORT_BUTTON = "table-export-button";
export const DATA_CY_TABLE_SAVE_BUTTON = "table-save-button";
export const DATA_CY_TABLE_ADD_NEW_FILTER_BUTTON = "table-add-new-filter-button";
export const DATA_CY_TABLE_COLUMN_PICKER = "table-column-picker";
export const DATA_CY_TABLE_DELETE_CONFIRMATION_BUTTON = "table-delete-confirmation-button";

export const DATA_CY_DATA_SCOPE_ITEM = "data-scope-item";
export const DATA_CY_DATA_SCOPE_FILTER_CONNECTIONS = "data-scope-filter-connections";
export const DATA_CY_DATA_SCOPE_SELECTION_CONNECTIONS = "data-scope-selection-connections";
export const DATA_CY_DATA_SCOPE_DISCONNECT_BUTTON = "data-scope-disconnect-button";

export const SIGN_OUT_MESSAGE = "Catcha next time";
export const TALLY_DESIGN_WELL_INPUT = "well-name-input";
export const DATA_CY_TALLY_DESIGN_WELL_INPUT_CONTAINER = "well-name-input-container";
export const DATA_CY_TALLY_DESIGN_WORKFLOW_CONTAINER = "workflow-name-input-container";
export const TALLY_DESIGN_WORKFLOW_INPUT = "workflow-name-input";
export const DATA_CY_TASK_RUNNER_LOGS = "task-runner-logs";

export const DATA_CY_DEBUGGER_CAMERA_TARGET = "debugger-camera-target";
export const DATA_CY_DEEP_INSIGHT_LOADER_OFF = "deep-insight-loader-off";
export const FILE_UPLOADER_AUTOCOMPLETE_DEEP_INSIGHT = "file-uploader-autocomplete-deep-insight";
export const DATA_CY_FILE_UPLOADER_AUTOCOMPLETE_DEEP_INSIGHT =
  "file-uploader-autocomplete-deep-insight";

export const DATA_CY_FILE_UPLOADER_INPUT_DEEP_INSIGHT = "file-uploader-input-deep-insight";

export const FILE_UPLOADER_BUTTON_DEEP_INSIGHT = "file-uploader-button-deep-insight";
export const DATA_CY_FILE_UPLOADER_BUTTON_DEEP_INSIGHT = "file-uploader-button-deep-insight";

export const DATA_CY_DEEP_INSIGHT_DATA_TABLE = "deep-insight-data-table";
export const SAVED_VIEWS_AUTOCOMPLETE = "saved-views-autocomplete";
export const DATA_CY_SAVED_VIEWS_AUTOCOMPLETE = "saved-views-autocomplete";
export const DATA_CY_LOAD_VIEWS_BUTTON = "load-views-button";
export const DATA_CY_COLOR_SCALE_MAX_INPUT = "color-scale-color-bar-max-input";
export const DATA_CY_DATE_SELECTOR_CONTAINER = "dashboard-date-container";
export const DASHBOARD_WELL_SELECTOR = "well-selector";
export const UPLOAD_DATE_SELECTOR = "upload-date-selector";
// view dropdown related bindings

export const DATA_CY_DATA_TABLE_IN_VIEW_DROPDOWN = "data-table-in-view-dropdown";
export const DATA_CY_DEEP_INSIGHT_VIEW_DROPDOWN = "deep-insight-view-dropdown";
export const DATA_CY_DEEP_INSIGHT_LAYER_DROPDOWN = "deep-insight-layer-dropdown";
export const DATA_CY_SCALE_IN_VIEW_DROPDOWN = "scale-in-view-dropdown";
export const DATA_CY_COLOR_SCALE_IN_VIEW_DROPDOWN = "color-scale-in-view-dropdown";
export const DATA_CY_ALL_INSPECTORS_IN_VIEW_DROPDOWN = "all-inspectors-in-view-dropdown";

export const DATA_CY_DATA_TABLE_TAB = (tabName: string) => `data-table-tab-${tabName}`;
// other constants

export const DEBUGGER_CAMERA_TARGET_TEXT = "Camera target well:";
// color scale pane

export const DATA_CY_COLOR_SCALE_AUTOCOMPLETE = "color-scale-autocomplete-deep-insight";
export const DATA_CY_WELL_SPHERE_TAB = "well-sphere-tab-deep-insight";
export const DATA_CY_WELL_PATH_TAB = "well-path-tab-deep-insight";
export const DATA_CY_GATHERING_NETWORK_TAB = "gn-tab-deep-insight";
export const DATA_CY_INFRASTRUCTURE_TAB = "infrastructure-tab-deep-insight";
export const DATA_CY_PRODUCTION_TAB = "production-tab-deep-insight";
export const DATA_CY_CONTOUR_TAB = "contour-tab-deep-insight";
export const DATA_CY_COLOR_SCALE_AUTO_SCALE = "auto-scale-color-deep-insight";
export const COLOR_PANE_ID = "color-scale-pane-deep-insight";
export const DATA_CY_COLOR_PANE = "color-scale-pane-deep-insight";
// other draggable windows
export const DATA_CY_SCALE_WINDOW = "scale-window";
// other panes

export const DATA_CY_DATA_INSPECTOR_PANE = "data-inspector-pane";

export const DATA_CY_ERROR_FALLBACK = "error-fallback";

export const DATA_CY_WELL_CARD_BUTTON = "header-icon-well-card";
// Well creation
export const DATA_CY_CREATE_WELL_BUTTON = "create-well-button";

// Well log plot
export const DATA_CY_WELL_LOG_PLOT_CASING = "well-plot-casing";
export const DATA_CY_WELL_LOG_PLOT_SCHEMATIC_HEADER = "well-plot-schematic-header";

export const DATA_CY_WELL_CREATION_NAME_FIELD = "well-creation-name-field";

export const DATA_CY_WELL_CREATION_LOCATION_FIELD = (
  // Known labels: "latitude" | "longitude" | "elevation" | "north" | "east" | "vertical".
  // Good to have as a reference, but it's too troublesome to enforce
  // in the well creation code itself.
  label: string,
  index: number
) => `well-creation-location-field-${label}-${index}`;

export const DATA_CY_WELL_CREATION_ADD_POINT_BELOW = (index: number) =>
  `well-creation-add-point-below-${index}`;

export const DATA_CY_WELL_CREATION_SUBMIT_BUTTON = "well-creation-submit-button";

// ui components
export const DATA_CY_PROGRESS_SPINNER = "progress-spinner";
export const DATA_CY_TOGGLE_BUTTON_DROPDOWN_TRIGGER = "toggle-button-dropdown-trigger";

export const DATA_CY_TASK_STATUS_CHECK = "task-status-check-display";
export const DATA_CY_TASK_STATUS_CHECK_ITEM = "task-status-check-display-item";
export const DATA_CY_TASK_STATUS_CHECK_RERUN = "task-status-check-rerun";

export const DATA_CY_SPECIFY_ZONES_MESSAGES = "specify-zones-messages";

export const DATA_CY_SIDEPANE_DASHBOARD_LOADING = "dashboard-loading-skeleton";

// Dashboard health beacon — emits data-dashboard-status for Playwright file-load tests.
// Status values: see DashboardHealthStatus enum.
export const DATA_CY_DASHBOARD_HEALTH = "dashboard-health";

export const DATA_CY_SIDEPANE_DASHBOARD_SETTINGS = "dashboard-settings";
export const DATA_CY_SIDEPANE_FOLDER_SETTINGS = "folder-settings";
